/** O app roda dentro do shell Tauri (desktop). Seguro no servidor: la devolve `false`. */
type TauriWindow = Window & { __TAURI_INTERNALS__?: unknown };

export const isTauriRuntime = (): boolean => typeof window !== "undefined" && !!(window as TauriWindow).__TAURI_INTERNALS__;
